import React, { memo, useContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import './css/GalleryThumbnail2.css';
import { NavLink } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import Button1 from '../../buttons/Button1';
import { context } from '../../../../globalState/GlobalState';
import { fetchPhotoAPI } from '../../../apiCalls/PhotoAPICalls';
import Spinner1 from '../../spinners/spinner1/Spinner1';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { getWebsiteImage } from '../../../../catalog/Website';

const initialState = {
    photoTitle: '',
    photoImage: '',
    loadingSpinner: true,
};

function reducer(state, action) {
    switch (action.type) {
        case 'fetchPhoto':
            return { ...state, photoTitle: action.photoTitle, photoImage: action.photoImage };
        case 'setLoadingSpinner':
            return { ...state, loadingSpinner: action.loadingSpinner };
        default:
            return initialState;
    }
}

const GalleryThumbnail2 = (props) => {
    const { gallery } = props;
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        async function fetchPhoto() {
            if (gallery.photoIds.length > 0) {
                await fetchPhotoAPI(gallery.photoIds[0], setState, enqueueSnackbar);
            }
            setState({ type: 'setLoadingSpinner', loadingSpinner: false });
        }
        fetchPhoto();
    }, []);

    const getImage = () => {
        if (isValidString(state.photoImage)) {
            return state.photoImage;
        } if (isValidObject(getWebsiteImage(globalState, 'galleryFeatureImage'))) {
            return getWebsiteImage(globalState, 'galleryFeatureImage');
        }
        return '';
    };

    const getTitle = (title) => {
        if (title.length > 50) {
            return `${title.substr(0, 50)}...`;
        }
        return title;
    };

    return (
        <NavLink to={`/galleries/${gallery.id}`}>
            <div className="gallery-thumbnail2-container text-left-align text-black text-no-underline">
                {state.loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                    <>
                        <img className="gallery-thumbnail2-image" src={getImage()} alt={gallery.title ? gallery.title : 'Article Title'} />
                        <div className="gallery-thumbnail2-text-container">
                            <div className="gallery-thumbnail2-button">
                                <Button1 title="Show More" transparent borderColor="white" fontColor="white" darkBackground />
                            </div>
                            <p className="gallery-thumbnail2-text m-t-0 m-b-0 p-t-10px p-b-20px p-l-20px p-r-20px font-size-s font-weight-800 text-white normal-font-family">{getTitle(gallery.title)}</p>
                        </div>
                    </>
                )}
            </div>
        </NavLink>
    );
};

GalleryThumbnail2.propTypes = {
    gallery: PropTypes.object.isRequired,
};

export default memo(GalleryThumbnail2);
